var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quantity-card",on:{"click":function($event){return _vm.openIssuesByState()}}},[_c('quantity-bg',{attrs:{"code":_vm.stringQuantityCode}}),_c('span',{staticClass:"quantity_title"},[_vm._v(_vm._s(_vm.quantity.title))]),_c('span',{staticClass:"quantity_value"},[_vm._v(_vm._s(_vm.quantity.value))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }